export * from './TrashCanIcon';
export * from './TrashCanIcon16Light';
export * from './TrashCanIcon16Regular';
export * from './TrashCanIcon16Solid';
export * from './TrashCanIcon20Light';
export * from './TrashCanIcon20Regular';
export * from './TrashCanIcon20Solid';
export * from './TrashCanIcon24Regular';
export * from './TrashCanIcon24Solid';
export * from './TrashCanIcon32Regular';
export * from './TrashCanIcon64Regular';
